var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatsHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 86,
    viewBox: "0 0 122 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7109 53.359L46.6781 35.5559C47.661 29.6585 55.0001 27.4763 59.0455 31.8786L59.4243 32.2908C62.0726 35.1728 66.6223 35.1639 69.2594 32.2717V32.2717C72.9644 28.2081 79.7188 30.125 80.7369 35.529L84.0962 53.359",
    stroke: "white",
    strokeWidth: 4.48725,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8203 61.7686H95.988",
    stroke: "white",
    strokeWidth: 4.48725,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.06 33.8475L19.4719 28.3756L14 25.7875L19.4719 23.1994L22.06 17.7275L24.648 23.1994L30.1199 25.7875L24.648 28.3756L22.06 33.8475Z",
    fill: "#F2C94C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6467 42.9145L31.8674 39.1526L28.1055 37.3733L31.8674 35.594L33.6467 31.832L35.426 35.594L39.1879 37.3733L35.426 39.1526L33.6467 42.9145Z",
    fill: "#F2C94C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1475 22.7647L33.177 20.7127L31.125 19.7422L33.177 18.7717L34.1475 16.7197L35.118 18.7717L37.17 19.7422L35.118 20.7127L34.1475 22.7647Z",
    fill: "#F2C94C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.795 45.7049L106.52 41.9166L110.168 40.1249L106.52 38.3332L104.795 34.5449L103.069 38.3332L99.4213 40.1249L103.069 41.9166L104.795 45.7049Z",
    fill: "#F2C94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0715 51.982L98.2577 49.3776L100.766 48.1458L98.2577 46.914L97.0715 44.3096L95.8853 46.914L93.3773 48.1458L95.8853 49.3776L97.0715 51.982Z",
    fill: "#F2C94C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.735 38.0326L97.382 36.612L98.75 35.9401L97.382 35.2682L96.735 33.8477L96.088 35.2682L94.72 35.9401L96.088 36.612L96.735 38.0326Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatsHat);
export default __webpack_public_path__ + "static/media/hats-hat.cabb9d6ccf687d5d6addc4c18232b5a6.svg";
export { ForwardRef as ReactComponent };